export const AvailabilityStatusTypes = [
  'NOT_ASSIGNED',
  'DISABLED',
  'READY_FOR_PRICING',
  'ENABLED',
  'DISCONTINUED',
];
